import { render } from "./NavigationEditPage.vue?vue&type=template&id=fcd71b1c"
import script from "./NavigationEditPage.vue?vue&type=script&lang=js"
export * from "./NavigationEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__